module.exports = __webpack_public_path__ + "img/chlg-soccer-logo-default.f60cd3a3.png";